var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('card',{attrs:{"title":"Unique Drivers"}},[_c('vue-apex-charts',{staticClass:"dashboard__chartContainer",attrs:{"type":"bar","height":"300","options":_vm.config.chartOptions,"series":_vm.config.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }